module.exports = __webpack_public_path__ + "img/1_023.81d38cad.jpg";